import "./i18n";
import "./index.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { createBrowserRouter, RouterProvider } from "react-router";
import { routerConfig } from "./router/router.config";
import { initService } from "./services/init.service";
import { AuthProvider } from "react-oidc-context";
import oidcConfig from "../oidc-client.config";
import { QueryClientProvider } from "@tanstack/react-query";
import { appQueryClient } from "./api";

// Initialize services
initService.initialize();

const router = createBrowserRouter(routerConfig);

createRoot(document.getElementById("root")!).render(
    <StrictMode>
        <AuthProvider {...oidcConfig}>
            <QueryClientProvider client={appQueryClient}>
                <RouterProvider router={router} />
            </QueryClientProvider>
        </AuthProvider>
    </StrictMode>,
);
